import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

export default {
    black,
    white,
    primary: {
        contrastText: white,
        dark: colors.brown[900],
        main: '#3A2411',
        light: '#AAA199'
    },
    secondary: {
        contrastText: white,
        dark: '#819D3C',
        main: '#A4B14C',
        light: '#DEECD1'
    },
    success: {
        contrastText: white,
        dark: colors.green[900],
        main: colors.green[600],
        light: colors.green[400]
    },
    info: {
        contrastText: white,
        dark: colors.blue[900],
        main: colors.blue[600],
        light: colors.blue[400]
    },
    warning: {
        contrastText: white,
        dark: colors.orange[900],
        main: colors.orange[600],
        light: colors.orange[400]
    },
    error: {
        contrastText: white,
        dark: colors.red[900],
        main: colors.red[600],
        light: colors.red[400]
    },
    text: {
        primary: '#3A2411',
        secondary: '#A4B14C',
        link: '#C16964'
    },
    background: {
        default: '#F4F6F8',
        paper: white
    },
    icon: '#A4B14C',
    divider: colors.grey[200]
};